//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Portal } from 'portal-vue'
import { getContentByCode} from "@/utils/utils";
export default {
  inject: ['$isMobile'],
  components: {
    Portal
  },
  props: {
    getPopupWeb: {
      type: Array,
      required: true
    },
    getPopupMob: {
      type: Array,
      required: true
    },
    getQr: {
      type: Array,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$isMobile()
    },
    text () {
      return this.isMobile ? this.getPopupMob[0].content || '' : this.getPopupWeb[0].content || ''
    }
  },
  // mounted() {
  //   disablePageScroll();
  // },
  // beforeDestroy() {
  //   enablePageScroll();
  // },
  methods: {
    close (...args) {
      /**
       * Клик на закрытии (крестик или подложка)
       */
      this.$emit('close', ...args)
    },
    getText(code) {
      return getContentByCode(this.getQrBlocks, code)
    },
    goToLink (link) {
      event.preventDefault()
      event.stopPropagation()
      window.open(link, '_blank')
    },
  }
}
